import { Link } from "@tanstack/react-router";
import { useI18n } from "@/lib/i18n";
import { ConsultCta } from "./consult-cta";

export function Footer() {
  const { t, lang } = useI18n();
  const de = lang === "de";
  return (
    <footer className="mt-16 border-t border-border/60 pb-24 md:pb-8">
      <div className="mx-auto max-w-6xl px-4 py-8 text-sm text-muted-foreground">
        <div className="grid gap-6 md:grid-cols-3">
          <div>
            <p className="font-semibold text-foreground">Retatrutid Thailand</p>
            <p className="mt-2">{t.footer.tagline}</p>
            <div className="mt-4">
              <ConsultCta variant="compact" />
            </div>
          </div>
          <div className="flex flex-col gap-1">
            <Link to="/wissenschaft" className="hover:text-foreground">{t.footer.linkScience}</Link>
            <Link to="/studien" className="hover:text-foreground">{t.footer.linkStudies}</Link>
            <Link to="/vergleich" className="hover:text-foreground">Vergleich · Comparison</Link>
            <Link to="/zulassung" className="hover:text-foreground">Zulassung · Approval</Link>
            <Link to="/rechner" className="hover:text-foreground">{t.footer.linkCalc}</Link>
            <Link to="/nebenwirkungen" className="hover:text-foreground">Nebenwirkungen · Side effects</Link>
            <Link to="/sicherheit" className="hover:text-foreground">{t.footer.linkSafety}</Link>
            <Link to="/faq" className="hover:text-foreground">FAQ</Link>
            <Link to="/ueber-uns" className="hover:text-foreground">{de ? "Über uns" : "About us"}</Link>
            <Link to="/kontakt" className="font-semibold text-indigo hover:text-foreground">
              {de ? "Beratung · Kontakt" : "Consultation · Contact"}
            </Link>
          </div>
          <p className="text-xs">{t.footer.disclaimer}</p>
        </div>
      </div>
    </footer>
  );
}
